import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEnvelope20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconEnvelope20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.5 4.5H3.494l6.51 6.51 6.51-6.51zm-14 9.945V5.627l4.409 4.409zM3.566 15.5h12.879l-4.405-4.404-1.505 1.505-.53.53-.53-.53-1.506-1.504zm9.535-5.465 4.399 4.399V5.636zM3.5 3A2.5 2.5 0 0 0 1 5.5v9A2.5 2.5 0 0 0 3.5 17h13a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 16.5 3z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEnvelope20);
